import { Platform } from "react-native";
const DEV_LOCALHOST = Platform.OS == "web" ? "http://localhost:3000" : "http://10.0.2.2:3000" 
const network = {
  serverip: __DEV__ ?  DEV_LOCALHOST :  "https://raftankitap-backend.vercel.app",
};
export default network;